import { imageStore } from '../images.js';
import PixelText from './PixelText.js';
import { c } from '../setup.js';

export default class SpeakerLabel {
    static SECTION_WIDTH = 8;
    static SECTION_HEIGHT = 24;

    constructor() {
        this.image = imageStore.get('img/overworld_textbox_name_label.png');
        this.speaker = '';
        this.visible = false;
        this.position = { x: 2, y: 112 - SpeakerLabel.SECTION_HEIGHT + 5 };
        this.textPadding = 4;
        this.speakerText = new PixelText({
            text: '',
            color: PixelText.blackTextColor,
            shadowColor: PixelText.whiteShadowColor,
            fontType: 'small',
            position: { x: 0, y: 0 },
        });
    }

    setSpeaker(speaker) {
        this.speaker = speaker || '';
        if (this.speaker.length > 0) {
            this.speaker = this.speaker.charAt(0).toUpperCase() + this.speaker.slice(1);
        }
        this.speakerText.text = this.speaker;
        this.visible = this.speaker.length > 0;
    }

    draw() {
        if (!this.visible || !this.speaker || !this.image || !this.image.complete) {
            return;
        }

        const textWidth = this.speakerText.measureTextWidth(this.speaker);
        const innerWidth = textWidth + this.textPadding * 2;
        const centerRepeats = Math.max(1, Math.ceil(innerWidth / SpeakerLabel.SECTION_WIDTH));

        const sw = SpeakerLabel.SECTION_WIDTH;
        const sh = SpeakerLabel.SECTION_HEIGHT;
        let drawX = this.position.x;

        // Left border
        c.drawImage(this.image, 0, 0, sw, sh, drawX, this.position.y, sw, sh);
        drawX += sw;

        // Center sections
        for (let i = 0; i < centerRepeats; i++) {
            c.drawImage(this.image, sw, 0, sw, sh, drawX, this.position.y, sw, sh);
            drawX += sw;
        }

        // Right border
        c.drawImage(this.image, sw * 2, 0, sw, sh, drawX, this.position.y, sw, sh);

        // Draw the text centered vertically in the label
        const totalBoxWidth = sw + (centerRepeats * sw) + sw;
        this.speakerText.position = {
            x: this.position.x + Math.round((totalBoxWidth - textWidth) / 2),
            y: this.position.y + Math.round((sh - this.speakerText.charHeight) / 2) - 2,
        };
        this.speakerText.draw();
    }
}
